import * as firebase from 'firebase';
import {firebaseConfig} from "./FIREBASE_CONFIG";

export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const firebaseDB = firebase.firestore(firebaseApp);
